module.exports = __webpack_public_path__ + "static/media/Why-is-My-Car-Not-Working-What-Can-I-Do-With-A-Non-Running-Car.ba9959f6.jpg";